import styled from 'styled-components';
import { Layouts } from '~/shared';

export const AnimationWrapper = styled.div`
	&.${Layouts.VehicleRegistration}-enter {
		.${Layouts.VehicleRegistration}-background {
			opacity: 0;
		}

		.${Layouts.VehiclePassport} {
			opacity: 0;
		}
	}

	&.${Layouts.VehicleRegistration}-enter-active,
		&.${Layouts.VehicleRegistration}-enter-done,
		&.${Layouts.VehicleRegistration}-exit {
		.${Layouts.VehicleRegistration}-background {
			opacity: 1;
		}

		.${Layouts.VehicleRegistration} {
			opacity: 1;
		}
	}

	&.${Layouts.VehicleRegistration}-exit-active {
		.${Layouts.VehicleRegistration}-background {
			opacity: 0;
		}

		.${Layouts.VehicleRegistration} {
			opacity: 0;
		}
	}
`;
